"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssertionResultDirectSuggestionsOutputDtoSchema = exports.assertionResultDirectSuggestionDtoSchema = exports.getAssertionResultDirectSuggestionsInputDtoSchema = exports.listAssertionResultFacetOptionsOutputDtoSchema = exports.assertionResultFacetOptionDtoSchema = exports.listAssertionResultFacetOptionsInputDtoSchema = exports.getAssertionResultFilterMetaOutputDtoSchema = exports.getAssertionResultFilterMetaInputDtoSchema = exports.getAssertionResultGroupCountsOutputDtoSchema = exports.assertionResultGroupCountSchema = exports.getAssertionResultGroupCountsInputDtoSchema = exports.getAssertionResultSummaryOutputDtoSchema = exports.getAssertionResultSummaryInputDtoSchema = exports.getAssertionResultGroupOutputDtoSchema = exports.linkedFindingDtoSchema = exports.getAssertionResultGroupInputDtoSchema = exports.listAssertionResultsGroupedOutputDtoSchema = exports.assertionResultGroupRollupSchema = exports.listAssertionResultsIndividualOutputDtoSchema = exports.assertionResultRowSchema = exports.listAssertionResultsGroupedInputDtoSchema = exports.listAssertionResultsIndividualInputDtoSchema = void 0;
const zod_1 = require("zod");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const list_build_design_objects_dto_js_1 = require("./list-build-design-objects.dto.js");
const enum_names_js_1 = require("./enum-names.js");
const findings_dto_js_1 = require("./findings.dto.js");
const log_entry_row_dto_js_1 = require("./log-entry-row.dto.js");
const query_builder_helpers_js_1 = require("./query-builder-helpers.js");
const severitySchema = sigma_engine_shared_1.RequirementsV2.RequirementSeveritySchema;
const workflowStateSchema = sigma_engine_shared_1.RequirementsV2.RequirementWorkflowStateSchema;
const severityNameSchema = enum_names_js_1.requirementSeverityNameSchema.describe('Name of the numeric `severity`, e.g. `Warning`.');
const workflowStateNameSchema = enum_names_js_1.requirementWorkflowStateNameSchema.describe('Name of the numeric `workflowState`, e.g. `Unreviewed`.');
const assertionResultListFilters = {
    buildId: zod_1.z.string(),
    limit: zod_1.z.number().min(1).max(1000).optional(),
    cursor: zod_1.z.string().optional(),
    searchQuery: zod_1.z.string().trim().max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.assertionResultFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
    sort: cadstrom_shared_1.QueryBuilder.createSortZodSchema(cadstrom_shared_1.RequirementsV2.assertionResultFilterSchema).optional(),
};
exports.listAssertionResultsIndividualInputDtoSchema = zod_1.z.object(assertionResultListFilters);
exports.listAssertionResultsGroupedInputDtoSchema = zod_1.z.object({
    ...assertionResultListFilters,
    limit: zod_1.z.number().min(1).max(500).optional(),
    requirementDefinitionIds: zod_1.z.string().array().max(100).optional(),
});
exports.assertionResultRowSchema = zod_1.z.object({
    id: zod_1.z.string(),
    projectId: zod_1.z.string(),
    buildId: zod_1.z.string(),
    requirementDefinitionId: zod_1.z.string(),
    assertionDefinitionId: zod_1.z.string(),
    resultSlug: zod_1.z.string(),
    severity: severitySchema,
    severityName: severityNameSchema,
    workflowState: workflowStateSchema,
    workflowStateName: workflowStateNameSchema,
    message: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    latestLogEntryId: zod_1.z.string().nullable(),
    latestLogEntryAt: zod_1.z.date().nullable(),
    continuityKeyType: sigma_engine_shared_1.RequirementsV2.ContinuityKeyTypeSchema.nullable(),
    continuityKey: zod_1.z.string().nullable(),
    legacyAnalysisRequirementResultId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
exports.listAssertionResultsIndividualOutputDtoSchema = zod_1.z.object({
    items: exports.assertionResultRowSchema.array(),
    hasNextPage: zod_1.z.boolean(),
    nextCursor: zod_1.z.string().nullable(),
});
exports.assertionResultGroupRollupSchema = zod_1.z.object({
    buildId: zod_1.z.string(),
    resultSlug: zod_1.z.string(),
    displaySlug: zod_1.z.string(),
    severity: severitySchema,
    severityName: severityNameSchema,
    workflowState: workflowStateSchema,
    workflowStateName: workflowStateNameSchema,
    message: zod_1.z.string().nullable(),
    memberCount: zod_1.z.number(),
    requirementDefinitionIds: zod_1.z.string().array(),
    members: exports.assertionResultRowSchema.array(),
});
exports.listAssertionResultsGroupedOutputDtoSchema = zod_1.z.object({
    groups: exports.assertionResultGroupRollupSchema.array(),
    hasNextPage: zod_1.z.boolean(),
    nextCursor: zod_1.z.string().nullable(),
});
exports.getAssertionResultGroupInputDtoSchema = zod_1.z.object({
    buildId: zod_1.z.string(),
    resultSlug: zod_1.z.string(),
});
exports.linkedFindingDtoSchema = zod_1.z.object({
    finding: findings_dto_js_1.findingRowDtoSchema,
    linkOrigin: sigma_engine_shared_1.RequirementsV2.FindingLinkOriginSchema,
    continuitySourceAssertionResultId: zod_1.z.string().nullable(),
});
exports.getAssertionResultGroupOutputDtoSchema = zod_1.z
    .object({
    buildId: zod_1.z.string(),
    resultSlug: zod_1.z.string(),
    rollup: exports.assertionResultGroupRollupSchema,
    members: exports.assertionResultRowSchema.array(),
    history: log_entry_row_dto_js_1.logEntryRowSchema.array(),
    linkedFindings: exports.linkedFindingDtoSchema.array(),
    designObjects: list_build_design_objects_dto_js_1.buildDesignObjectSchema.array(),
})
    .nullable();
exports.getAssertionResultSummaryInputDtoSchema = zod_1.z.object({
    buildId: zod_1.z.string(),
});
exports.getAssertionResultSummaryOutputDtoSchema = zod_1.z.object({
    buildId: zod_1.z.string(),
    totalCount: zod_1.z.number(),
    bySeverity: zod_1.z.partialRecord(zod_1.z.coerce.number().pipe(severitySchema), zod_1.z.number()),
    byWorkflowState: zod_1.z.partialRecord(zod_1.z.coerce.number().pipe(workflowStateSchema), zod_1.z.number()),
    bySeverityName: zod_1.z.partialRecord(enum_names_js_1.requirementSeverityNameSchema, zod_1.z.number()),
    byWorkflowStateName: zod_1.z.partialRecord(enum_names_js_1.requirementWorkflowStateNameSchema, zod_1.z.number()),
});
exports.getAssertionResultGroupCountsInputDtoSchema = zod_1.z.object({
    buildId: zod_1.z.string(),
    searchQuery: zod_1.z.string().trim().max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.assertionResultFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
});
exports.assertionResultGroupCountSchema = zod_1.z.object({
    requirementDefinitionId: zod_1.z.string(),
    childGroupCount: zod_1.z.number(),
    severity: severitySchema,
    severityName: severityNameSchema,
    workflowState: workflowStateSchema,
    workflowStateName: workflowStateNameSchema,
});
exports.getAssertionResultGroupCountsOutputDtoSchema = zod_1.z.object({
    groupCounts: exports.assertionResultGroupCountSchema.array(),
});
const assertionResultFacetIdSchema = zod_1.z.enum([
    'severity',
    'workflowState',
    'resultSlug',
    'requirementDefinitionId',
    'assertionDefinitionId',
    'designObject',
    'hasFinding',
]);
exports.getAssertionResultFilterMetaInputDtoSchema = zod_1.z.object({
    buildId: zod_1.z.string(),
    searchQuery: zod_1.z.string().trim().max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.assertionResultFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
});
exports.getAssertionResultFilterMetaOutputDtoSchema = zod_1.z.object({
    totalCount: zod_1.z.number(),
    filteredCount: zod_1.z.number(),
});
exports.listAssertionResultFacetOptionsInputDtoSchema = zod_1.z.object({
    buildId: zod_1.z.string(),
    facetId: assertionResultFacetIdSchema,
    valueSearch: zod_1.z.string().trim().max(200).optional(),
    searchQuery: zod_1.z.string().trim().max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.assertionResultFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
});
exports.assertionResultFacetOptionDtoSchema = zod_1.z.object({
    value: zod_1.z.string(),
    label: zod_1.z.string(),
    count: zod_1.z.number(),
    group: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
});
exports.listAssertionResultFacetOptionsOutputDtoSchema = zod_1.z.object({
    options: exports.assertionResultFacetOptionDtoSchema.array(),
});
exports.getAssertionResultDirectSuggestionsInputDtoSchema = zod_1.z.object({
    buildId: zod_1.z.string(),
    query: zod_1.z.string().trim().min(1).max(200),
    searchQuery: zod_1.z.string().trim().max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.assertionResultFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
});
exports.assertionResultDirectSuggestionDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    facetId: assertionResultFacetIdSchema,
    facetLabel: zod_1.z.string(),
    operator: zod_1.z.literal('is'),
    value: zod_1.z.string(),
    label: zod_1.z.string(),
    count: zod_1.z.number(),
    description: zod_1.z.string().optional(),
});
exports.getAssertionResultDirectSuggestionsOutputDtoSchema = zod_1.z.object({
    suggestions: exports.assertionResultDirectSuggestionDtoSchema.array(),
});
//# sourceMappingURL=list-assertion-results.dto.js.map